import axios, { AxiosResponse } from "axios";
import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { ApplicationAttributeState, ApplicationAttributeFilterParams, ApplicationAttributeItem } from './types';


export const actions: ActionTree<ApplicationAttributeState, RootState> = {
  async getApplicationAttributes({commit}, data: {application_id: number, filter: ApplicationAttributeFilterParams}) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{ attributes: ApplicationAttributeItem[] }> = await axios({
        url: `/acapi/push/applications/${data.application_id}/attributes`,
        params: data.filter,
      });
      commit("setApplicationAttributes", resp.data.attributes);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getApplicationAttributeItem({commit}, data: {id: number, application_id: number}){
    commit('setLoading', true);
    try {
      const resp:AxiosResponse<ApplicationAttributeItem> = await axios({
        url: `/acapi/push/applications/${data.application_id}/attributes/${data.id}`
      })
      const attribute = resp.data;
      attribute.id = data.id;
      commit(`setApplicationAttributeItem`, attribute);
      return attribute;
    } finally {
      commit('setLoading', false);
    }
  },
  async saveApplicationAttribute({commit, dispatch}, data: {item: ApplicationAttributeItem, application_id: number}) {
    commit('setLoading', true);
    try {
      const resp:AxiosResponse<any> = await axios({
        method: data.item.id ? 'put' : 'post',
        url: `/acapi/push/applications/${data.application_id}/attributes/${(data.item.id ?? '')}`,
        data: data.item,
      })
      dispatch('getApplicationAttributes',{application_id: data.application_id});
      return resp;
    } finally {
      commit('setLoading', false);
    }
  },
  async deleteApplicationAttribute({commit, dispatch}, data: {item: ApplicationAttributeItem, application_id: number}) {
    commit('setLoading', true);
    try {
      const resp:AxiosResponse<any> = await axios({
        method: 'delete',
        url: `/acapi/push/applications/${data.application_id}/attributes/${(data.item.id ?? '')}`,
        data: data.item,
      })
      dispatch('getApplicationAttributes',{application_id: data.application_id});
      return resp;
    } finally {
      commit('setLoading', false);
    }
  },
}